import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import BtbUseRoomReport from './BtbUseRoomReport';
import * as reportAction from '../../../../../actions/reportAction';



const mapStateToProps = state => {
    return {
        btbUseRoomState: state.reportReducer.btbUseRoomReport,
        loadingBtbUseRoom: state.reportReducer.isFetchingBtbUseRoom,
        isFetchingExportBtbUseRoom: state.reportReducer.isFetchingExportBtbUseRoom,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBtbUseRoomReport: (filters) => dispatch(reportAction.getBtbUseRoomReport(filters)),
        getExportBtbUseRoomReport: (data) => dispatch(reportAction.getExportBtbUseRoomReport(data)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(BtbUseRoomReport));
